import { Injectable } from '@angular/core';
import { IndicatorService } from './reload-indicator.service';


@Injectable({
  providedIn: 'root'
})
export class MoveIndicatorControlService extends IndicatorService {

}
